<template>
  <svg
    v-show="active"
    id="eL5ZiUvOXIJ1"
    shape-rendering="geometricPrecision"
    text-rendering="geometricPrecision"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="eL5ZiUvOXIJ2" transform="translate(0-1)">
      <path
        d="M16,26c5.2467,0,9.5-4.2533,9.5-9.5s-4.2533-9.5-9.5-9.5-9.5,4.2533-9.5,9.5s4.2533,9.5,9.5,9.5Z"
        fill="#fff"
        stroke="#016dbf"
        stroke-width="2"
      />
      <path
        clip-rule="evenodd"
        d="M23.5772,22.2311C21.8426,24.5209,19.094,26,16,26s-5.8426-1.4791-7.57721-3.7689C10.3337,20.2397,13.0221,19,16,19s5.6663,1.2397,7.5772,3.2311Z"
        fill="#fff"
        fill-rule="evenodd"
      />
      <path
        d="M23.5772,22.2311l.7971.6039.5154-.6804-.591-.6158-.7215.6923Zm-15.15441,0l-.72155-.6923-.59095.6158.5154.6804.7971-.6039ZM16,27c3.4204,0,6.4588-1.6365,8.3743-4.165l-1.5942-1.2077C21.2264,23.6782,18.7677,25,16,25v2ZM7.62569,22.835C9.54116,25.3635,12.5796,27,16,27v-2c-2.7677,0-5.2264-1.3218-6.78011-3.3727L7.62569,22.835ZM16,18c-3.2614,0-6.20709,1.3589-8.29876,3.5388l1.4431,1.3847C10.8745,21.1204,13.3055,20,16,20v-2Zm8.2987,3.5388C22.2071,19.3589,19.2614,18,16,18v2c2.6944,0,5.1255,1.1204,6.8556,2.9235l1.4431-1.3847Z"
        fill="#016dbf"
      />
      <path
        d="M16,16c1.3807,0,2.5-1.1193,2.5-2.5s-1.1193-2.5-2.5-2.5-2.5,1.1193-2.5,2.5s1.1193,2.5,2.5,2.5Z"
        fill="#fff"
        stroke="#016dbf"
        stroke-width="2"
      />
    </g>
    <g id="eL5ZiUvOXIJ7" opacity="0" transform="translate(0-1)">
      <path
        d="M16,26c5.2467,0,9.5-4.2533,9.5-9.5s-4.2533-9.5-9.5-9.5-9.5,4.2533-9.5,9.5s4.2533,9.5,9.5,9.5Z"
        fill="#000860"
        stroke="#000860"
        stroke-width="2"
      />
      <path
        clip-rule="evenodd"
        d="M23.5772,22.2311C21.8426,24.5209,19.094,26,16,26s-5.8426-1.4791-7.57721-3.7689C10.3337,20.2397,13.0221,19,16,19s5.6663,1.2397,7.5772,3.2311Z"
        fill="#fff"
        fill-rule="evenodd"
        stroke-width="2"
      />
      <path
        d="M23.5772,22.2311l.7971.6039.5154-.6804-.591-.6158-.7215.6923Zm-15.15441,0l-.72155-.6923-.59095.6158.5154.6804.7971-.6039ZM16,27c3.4204,0,6.4588-1.6365,8.3743-4.165l-1.5942-1.2077C21.2264,23.6782,18.7677,25,16,25v2ZM7.62569,22.835C9.54116,25.3635,12.5796,27,16,27v-2c-2.7677,0-5.2264-1.3218-6.78011-3.3727L7.62569,22.835ZM16,18c-3.2614,0-6.20709,1.3589-8.29876,3.5388l1.4431,1.3847C10.8745,21.1204,13.3055,20,16,20v-2Zm8.2987,3.5388C22.2071,19.3589,19.2614,18,16,18v2c2.6944,0,5.1255,1.1204,6.8556,2.9235l1.4431-1.3847Z"
        fill="#000860"
      />
      <g id="eL5ZiUvOXIJ11_to" transform="translate(16,21.5)">
        <path
          id="eL5ZiUvOXIJ11"
          d="M16,16c1.3807,0,2.5-1.1193,2.5-2.5s-1.1193-2.5-2.5-2.5-2.5,1.1193-2.5,2.5s1.1193,2.5,2.5,2.5Z"
          fill="#fff"
          opacity="0"
          stroke="#fff"
          stroke-width="2"
          transform="translate(-16,-13.5)"
        />
      </g>
    </g>
  </svg>
</template>

<script lang="ts" setup>
type Props = {
  active?: boolean
}

defineProps<Props>()
</script>

<style lang="css">
/* stylelint-disable */

#eL5ZiUvOXIJ2 {
  animation: eL5ZiUvOXIJ2_c_o 800ms linear 1 normal forwards;
}
@keyframes eL5ZiUvOXIJ2_c_o {
  0% {
    opacity: 1;
  }

  25% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
}

#eL5ZiUvOXIJ7 {
  animation: eL5ZiUvOXIJ7_c_o 800ms linear 1 normal forwards;
}
@keyframes eL5ZiUvOXIJ7_c_o {
  0% {
    opacity: 0;
  }

  12.5% {
    opacity: 0;
  }

  25% {
    opacity: 1;
  }

  100% {
    opacity: 1;
  }
}

#eL5ZiUvOXIJ11_to {
  animation: eL5ZiUvOXIJ11_to__to 800ms linear 1 normal forwards;
}
@keyframes eL5ZiUvOXIJ11_to__to {
  0% {
    transform: translate(16px, 21.5px);
  }

  25% {
    transform: translate(16px, 21.5px);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }

  61.25% {
    transform: translate(16px, 12px);
    animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
  }

  82.5% {
    transform: translate(16px, 14px);
  }

  100% {
    transform: translate(16px, 14px);
  }
}

#eL5ZiUvOXIJ11 {
  animation: eL5ZiUvOXIJ11_c_o 800ms linear 1 normal forwards;
}
@keyframes eL5ZiUvOXIJ11_c_o {
  0% {
    opacity: 0;
  }

  25% {
    opacity: 0;
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }

  32.5% {
    opacity: 1;
  }

  100% {
    opacity: 1;
  }
}

#eL5ZiUvOXIJ2 {
  animation: eL5ZiUvOXIJ2_c_o 800ms linear 1 normal forwards;
}
@keyframes eL5ZiUvOXIJ2_c_o {
  0% {
    opacity: 1;
  }

  25% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
}

#eL5ZiUvOXIJ7 {
  animation: eL5ZiUvOXIJ7_c_o 800ms linear 1 normal forwards;
}
@keyframes eL5ZiUvOXIJ7_c_o {
  0% {
    opacity: 0;
  }

  12.5% {
    opacity: 0;
  }

  25% {
    opacity: 1;
  }

  100% {
    opacity: 1;
  }
}

#eL5ZiUvOXIJ11_to {
  animation: eL5ZiUvOXIJ11_to__to 800ms linear 1 normal forwards;
}
@keyframes eL5ZiUvOXIJ11_to__to {
  0% {
    transform: translate(16px, 21.5px);
  }

  25% {
    transform: translate(16px, 21.5px);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }

  61.25% {
    transform: translate(16px, 12px);
    animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
  }

  82.5% {
    transform: translate(16px, 14px);
  }

  100% {
    transform: translate(16px, 14px);
  }
}

#eL5ZiUvOXIJ11 {
  animation: eL5ZiUvOXIJ11_c_o 800ms linear 1 normal forwards;
}
@keyframes eL5ZiUvOXIJ11_c_o {
  0% {
    opacity: 0;
  }

  25% {
    opacity: 0;
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }

  32.5% {
    opacity: 1;
  }

  100% {
    opacity: 1;
  }
}
</style>
